import React, { useState } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import AiDraftPopover from './Popover'
import { makeAiAnalysisQueryClient } from '../queryClient'
import type { AiDraftPopoverProps } from './types'

const AiDraftPopoverWrapper: React.FC<AiDraftPopoverProps> = (props) => {
  const [queryClient] = useState(makeAiAnalysisQueryClient)

  return (
    <QueryClientProvider client={queryClient}>
      <AiDraftPopover {...props} />
    </QueryClientProvider>
  )
}

export default AiDraftPopoverWrapper
